<template>
  <div
    class="modal fade"
    id="resumeCategoryModal"
    data-focus="false"
    data-keyboard="false"
    data-backdrop="static"
    style="z-index: 1000000"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">履歷分類</h5>
        </div>
        <div class="modal-body">
          <div class="form-group form-inline">
            <label for="">經驗分類-主分類</label>
            <multiselect
              :options="resumeTagOptions"
              :close-on-select="false"
              tagPlaceholder=""
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              label="Name"
              track-by="Guid"
              placeholder="請選擇"
              v-model="person.MainResumeTag"
            />
          </div>
          <div class="form-group form-inline">
            <label for="">經驗分類-次分類</label>
            <multiselect
              :options="resumeTagOptions"
              :close-on-select="false"
              multiple
              tagPlaceholder=""
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              label="Name"
              track-by="Guid"
              placeholder="請選擇"
              v-model="person.ResumeTags"
            />
          </div>
          <div class="form-group form-inline">
            <label for="">
              其他分類<span class="mark">（新增字數不可超過20個字）</span>
            </label>
            <multiselect
              :options="freeTagOptions"
              :taggable="true"
              :close-on-select="false"
              multiple
              tagPlaceholder=""
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              label="Name"
              track-by="Guid"
              placeholder="請選擇或自行新增"
              @tag="addTag"
              v-model="person.ResumeFreeTags"
            />
          </div>
          <div class="form-group form-inline">
            <label for="">後續聯絡</label>
            <multiselect
              :options="['可再約', '永不聯絡']"
              placeholder="請選擇"
              v-model="person.ResumeContactRemark"
            />
          </div>
          <div class="form-group form-inline">
            <label for="">備註</label>
            <el-input
              class="w-100"
              type="textarea"
              :rows="8"
              maxlength="400"
              show-word-limit
              v-model="person.Remark"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            關閉
          </button>
          <button
            v-if="fromPage !== '歷史人才查詢'"
            type="button"
            class="btn btn-primary"
            @click="putResumeTag"
          >
            儲存
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters } from "vuex";

export default {
  props: ["ResumeId"],

  name: "ResumeTagModal",

  data() {
    return {
      // 從哪個頁面來
      fromPage: "",

      person: {},
    };
  },

  computed: {
    ...mapGetters(["showResumeCategory", "resumeTagOptions", "freeTagOptions"]),
  },

  watch: {
    showResumeCategory: async function (e) {
      if (e) {
        await this.getResumeTag();
      } else {
        this.opened = false;
        $("#resumeCategoryModal").modal("hide");
      }
    },
  },

  methods: {
    // 取得 履歷分類與其他分類
    getResumeTag() {
      this.$api.resumeTag.getTagByResumeId(this.ResumeId).then((response) => {
        if (response.status === 200) {
          this.person = response.data;
        }
      });
      $("#resumeCategoryModal").modal("show");
    },

    // 編輯分類
    putResumeTag() {
      this.$api.resumeTag
        .putResumeTag({ ...this.person })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "分類儲存成功",
              type: "success",
              duration: 2000,
            });
            this.closeModal();
          }
        });
    },
    
    // 點擊關閉
    closeModal() {
      this.$store.commit("OpenResumeCategoryModal", false);
    },

    // 增加分類
    addTag(newTag) {
      if (newTag.length > 20) {
        return;
      }
      const tag = {
        Guid: null,
        Name: newTag,
      };
      this.freeTagOptions.push(tag);
      this.person.ResumeFreeTags.push(tag);
    },
  },

  created() {
    this.fromPage = localStorage.FROM_PAGE.split(",")[1];
    // 取得 履歷分類標簽
    this.$store.dispatch("GetResumeTag");
    // 取得 其他分類標簽
    this.$store.dispatch("GetFreeTag");
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.$store.commit("OpenResumeCategoryModal", false);
  },
};
</script>
